import React, { useState } from 'react';
import InputForm from '../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, CircularProgress, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Input, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Clear, DataArray, MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SearchInput from '../../../SearchInput';
import CheckBox from '../../../CheckBox';
import SearchModal from '../../../SearchModal';
import RadioBox from '../../../Radiox';
import TextArea from 'antd/es/input/TextArea';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import axios from 'axios';
import DataTypeTable from '../../../../Types/DataTypeTable';
import SweetAlert from "sweetalert2"
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Data from '../../../../Data/Data.json'
import { DownOutlined } from '@ant-design/icons';
import Spin from 'antd/es/spin';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import formatDate from '../../../../Functions/Traitement/fomatDate';







//Initialisation des parametres de recherche
//
let searchPret: Params = { CodeAgence: '', Table: "PRETS", Colonne1: "NUMDOS", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchPeriod: Params = { CodeAgence: '', Table: "v_period_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeAmort: Params = { CodeAgence: '', Table: "v_typeAmortissement_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeCalcul: Params = { CodeAgence: '', Table: "v_typeCalcul_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypePret: Params = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchNature: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

interface SelectData {
  value: string,
  label: string,
}

function Tab1(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const [competClients, SetCompetClients] = React.useState<SelectData[]>([]);
  const [loading, setLoading] = useState(false)
  const [loadCompte, setLoadCompte] = useState(false)
  //const [historiques, setHistoriques] = useState<Array<any>>([])



  // USER TOKEN
  const authHeader = useAuthHeader()




  const columns: ColumnsType<any> = [
    {
      title: 'Montant',
      dataIndex: 'MTDEC',
    },
    {
      title: 'Utilisateur',
      dataIndex: 'UTIDEC',
    },
    {
      title: 'Date',
      dataIndex: 'DATDEC',
    },
    {
      title: 'Raison',
      dataIndex: 'RAISON',
    }
  ];


  function loadGarantie() {
    localStorage.setItem("garanties_client", "")
    localStorage.setItem(Datas.LocalVariable.garantie, "")
    try {
      let numcli = props.form.getFieldValue("NUMCLI")
      numcli += Datas.LocalVariable.separator + "CL"

      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.GetGarantie,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(numcli))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;


            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              //alert(datas.length)
              if (datas.length === 0) {
                localStorage.setItem("garanties_client", "")
              }
              else {
                localStorage.setItem("garanties_client", Crypter.encrypt(JSON.stringify(datas)))
              }
            }
          }

        }).catch((error) => {
          localStorage.setItem("garanties_client", "")
          SweetAlert.fire({ title: "Error", text: error })
        })
    } catch (error) {
      SweetAlert.fire({ title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: "warning" })
      localStorage.setItem("garanties_client", "")
    }
  }

  function loadAvaliste() {
    localStorage.setItem("avalistes_client", "")
    localStorage.setItem(Datas.LocalVariable.garantie, "")
    try {
      let numcli = props.form.getFieldValue("NUMCLI")
      //numcli += Datas.LocalVariable.separator + "CL"
      //alert(numcli)
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.GetRelation,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherNumcli': Crypter.encrypt(JSON.stringify(numcli))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));


            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              //alert(datas.length)
              if (datas.length === 0) {
                localStorage.setItem("avalistes_client", "")
              }
              else {
                localStorage.setItem("avalistes_client", Crypter.encrypt(JSON.stringify(datas)))
              }
            }
          }

        }).catch((error) => {
          localStorage.setItem("avalistes_client", "")
          SweetAlert.fire({ title: "Error", text: error })
        })
    } catch (error) {
      SweetAlert.fire({ title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: "warning" })
      localStorage.setItem("avalistes_client", "")
    }
  }
  return (
    <div className='tabItemAuto'>
      <div >
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>

          <Box display={"flex"} fontStyle={"inherit"}>
            <Box fontStyle="inherit" className='border-left'>
              <SearchInput width={9} form={props.form} Titre='Recherche Dossier' label='Numero Dossier' name='NUMDOS' Parametre={searchPret} />
              <SearchModal width={9} form={props.form} Titre="Recherche Indice client" label='Indice client' name='NUMCLI' Parametre={searchIndice} />
            </Box>
            <Box fontStyle="inherit" className='border-left'>
              <SearchModal width={9} form={props.form} Titre='Recherche Acivité' label='Acitivité économique' name='CDENAE' Parametre={searchNature} />
              <SearchModal width={9} form={props.form} Titre="Recherche Gestionnaire" label='Gestionnaire' name='CODGES' Parametre={searchGes} />
            </Box>
          </Box>
          <Box marginTop={"-15px"}>
            <RadioBox disabled={false} name={'option'} Value1={'0'} Value2={'1'} Value3={'2'} Value4={'3'} LibValue1={"Transfert impyé dans dépôt (Forcer la reprise impayé))"} libVlue2={"Transfert intérêt en hors bilan"} libVlue3={"Transfert capital en créance douteux sans effet contagion"}  libVlue4={"Transfert capital en créance douteux avec effet contagion"} />
          </Box>
        </Box>
      </div>
    </div>
  )
}
export default Tab1;